import Vue from "vue"

export const namespaced = true

export const state = {
  clients: [],
  filters: {},
  meta: { totalData: 0 },
}

export const getters = {
  clientById: (state) => (clientId) =>
    state.clients.find((it) => it.id === clientId),
}

export const mutations = {
  setClients(state, payload) {
    state.clients = payload
  },
  setClient(state, client) {
    let index = state.clients.findIndex((it) => it.id === client.id)
    if (index === -1) {
      state.clients.push(client)
    } else {
      Vue.set(state.clients, index, client)
    }
  },
  setFilter(state, { key, value }) {
    Vue.set(state, key, value)
  },
  setTotalData(state, total) {
    state.meta.totalData = total
  },
}

export const actions = {
  listClients(ctx, { page, perPage, search, status } = {}) {
    let axios = ctx.rootGetters.axios
    let params = new URLSearchParams()
    if (page != null) params.set("page", page)
    if (perPage != null) params.set("perpage", perPage)
    if (search != null) params.set("q", search)
    if (status != null) params.set("status", status)

    return axios
      .get(`/v1/admin/clients?${params.toString()}`)
      .then((r) => r.data)
      .then((data) => {
        ctx.commit("setClients", data.data)
        ctx.commit("setTotalData", data.meta.total)
        return data.data
      })
  },
  getClientById(ctx, clientId) {
    let axios = ctx.rootGetters.axios

    return axios
      .get(`/v1/admin/clients/${clientId}`)
      .then((r) => r.data.data)
      .then((client) => {
        ctx.commit("setClient", client)
        return client
      })
  },
  createClient(ctx, client) {
    let axios = ctx.rootGetters.axios
    return axios
      .post(`/v1/admin/clients`, client)
      .then((r) => r.data.data)
      .then((r) => {
        ctx.commit("setClient", r)
        return r
      })
  },
  updateClient(ctx, client) {
    let axios = ctx.rootGetters.axios
    return axios
      .put(`/v1/admin/clients/${client.id}`, client)
      .then((r) => r.data.data)
      .then((r) => {
        ctx.commit("setClient", r)
        return r
      })
  },
  getProgramById(ctx, programId) {
    let axios = ctx.rootGetters.axios

    return axios
      .get(`/v1/admin/programs/${programId}/details`)
      .then((r) => r.data.data)
      .then((program) => {
        // ctx.commit("setProgram", program);
        return program
      })
  },
  listNutritionist(ctx, { page }) {
    let axios = ctx.rootGetters.axios

    return axios.get(`/v1/admin/nutritionist?page=${page}`).then((r) => {
      console.log("r.data", r.data)
      return r.data
    })
  },
  updateProgramNutritionist(ctx, { programId, nutritionistId }) {
    let axios = ctx.rootGetters.axios
    return axios
      .post(`/v1/admin/programs/${programId}/update-nutritionist`, {
        nutritionistId,
      })
      .then((r) => r.data.data)
  },
}
